// Web override: expo-router hooks (useSegments/usePathname) crash with
// "Cannot read properties of null (reading 'getSnapshot')" during React 19's
// renderWithHooksAgain phase. Use window.location.pathname directly instead.

export enum ActionType {
  SCREEN,
  PRESSABLE,
}

export const useAnalyticsScreenKey = (action: ActionType) => {
  const pathname =
    typeof window !== 'undefined' ? window.location.pathname : '';
  const segments = pathname.split('/').filter(Boolean);
  const filteredSegments = segments.filter((segment) => !segment.includes('('));

  switch (action) {
    case ActionType.SCREEN:
      return filteredSegments.length === 0
        ? '/'
        : `/${filteredSegments.join('/')}`;
    case ActionType.PRESSABLE:
      return filteredSegments.length === 0
        ? ''
        : `/${filteredSegments.join('/')}`;
    default:
      return '';
  }
};
